export default __webpack_public_path__ + "static/media/avatar_dog4.98cd9956.mp3";